import { render, staticRenderFns } from "./news-edit.vue?vue&type=template&id=4f67c683&scoped=true&"
import script from "./news-edit.vue?vue&type=script&lang=ts&"
export * from "./news-edit.vue?vue&type=script&lang=ts&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"
import style1 from "./news-edit.vue?vue&type=style&index=1&id=4f67c683&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f67c683",
  null
  
)

export default component.exports